export default {
  intelligentOfficialDoc_my_test: '我的测试',
  intelligentOfficialDoc_practice: '练习',
  intelligentOfficialDoc_self_assessment: '自评',
  intelligentOfficialDoc_test: '测试',
  intelligentOfficialDoc_total: '全部',
  intelligentOfficialDoc_level01: '大神，请收下我的膝盖',
  intelligentOfficialDoc_level02: '大神，请收下我的膝盖',
  intelligentOfficialDoc_level03: '百炼始成钢，相信自己会做的更好',
  intelligentOfficialDoc_level04: '开挂的人生，从不畏惧失败',
  intelligentOfficialDoc_level05: '开挂的人生，从不畏惧失败',
  intelligentOfficialDoc_ranking: '当前排名：第{rank}名',
  intelligentOfficialDoc_rank_percent: '已超过{rankPercent}%的小伙伴',
  intelligentOfficialDoc_check_resolution: '查看解析',
  intelligentOfficialDoc_practice_num_score: '已累计训练{practiceNum}次，最高得分{topScore}分',
  intelligentOfficialDoc_practice_notes: '查看练习记录',
  intelligentOfficialDoc_start_practicing: '开始练习',
  intelligentOfficialDoc_intelligent_writing: '智能公文写作',
  intelligentOfficialDoc_AI_reviewing: 'AI智能评审中，请等待…',
  intelligentOfficialDoc_exit_check_list: '您可先行退出，评审完成后进入任务列表查看结果',
  intelligentOfficialDoc_review_progress: '评审进度',
  intelligentOfficialDoc_positive_completion_time: '按完成时间正序排列',
  intelligentOfficialDoc_reverse_completion_time: '按完成时间倒序排列',
  intelligentOfficialDoc_order_number: '序号',
  intelligentOfficialDoc_title_name: '名称',
  intelligentOfficialDoc_type: '类型',
  intelligentOfficialDoc_completed_time: '完成时间',
  intelligentOfficialDoc_operation: '操作',
  intelligentOfficialDoc_achievement: '成绩',
  intelligentOfficialDoc_task_type: '任务类型',
  intelligentOfficialDoc_sort_order: '排序方式',
  intelligentOfficialDoc_enter_title: '请输入名称',
  intelligentOfficialDoc_check_detail: '查看详情',
  intelligentOfficialDoc_waiting_review: '等待评审',
  intelligentOfficialDoc_no_permission: '暂无权限',
  intelligent_files: '我的智能公文',
  intelligentOfficialDoc_no_subject: '暂无题目',
  intelligentOfficialDoc_result_report: '成绩报告',
  intelligentOfficialDoc_spacie_indent: '行距缩进',
  intelligentOfficialDoc_title_end: '标题结尾',
  intelligentOfficialDoc_hierarchy_label: '层次标号',
  intelligentOfficialDoc_conference_presentation: '会议表述',
  intelligentOfficialDoc_meeting_elements: '会议要素',
  intelligentOfficialDoc_Background_objective: '背景目标',
  intelligentOfficialDoc_core_consensus: '核心共识',
  intelligentOfficialDoc_action_plan: '行动计划',
  intelligentOfficialDoc_overall_structure: '整体结构',
  intelligentOfficialDoc_paragraph_structure: '段落结构',
  intelligentOfficialDoc_hierarchical_structure: '层次结构',
  intelligentOfficialDoc_concise_language: '语言精练',
  intelligentOfficialDoc_limit_word_num: '字数限制',
  intelligentOfficialDoc_statement_specification: '语句规范',
  intelligentOfficialDoc_punctuation_words: '字词标点',
  intelligentOfficialDoc_issue_number: "出现{number}处问题",
  intelligentOfficialDoc_review_Report: '《{topicTitle}》会议纪要写作智能评审报告',
  intelligentOfficialDoc_actual_time: '实际用时：{timeLimit}分钟',
  intelligentOfficialDoc_completion_time: '完成时间：{doneDate}',
  intelligentOfficialDoc_total_scores: '{testType}总得分',
  intelligentOfficialDoc_cur_rank: '当前排名:',
  intelligentOfficialDoc_rank:'排名',
  intelligentOfficialDoc_total_num: '当前参与测试总人数：{total}人',
  intelligentOfficialDoc_format_style: '格式体例',
  intelligentOfficialDoc_idea_content: '思想内容',
  intelligentOfficialDoc_logical_structure:'逻辑结构',
  intelligentOfficialDoc_linguistic_performance:'语言运用',
  intelligentOfficialDoc_format_score:'格式体例({noSelf}分)',
  intelligentOfficialDoc_idea_content_score:'思想内容(30分)',
  intelligentOfficialDoc_logical_score:'逻辑结构({noSelf}分)',
  intelligentOfficialDoc_linguistic_score:'语言运用({noSelf}分)',
  intelligentOfficialDoc_check_detail:'下拉查看评审详情',
  intelligentOfficialDoc_accurate_analysis:'精准分析',
  intelligentOfficialDoc_reference_model:'参考范文',
  intelligentOfficialDoc_keep_practicing:'继续练习',
  intelligentOfficialDoc_Illegal_character:'{msg}存在非法字符，无法正确标注',
  intelligentOfficialDoc_review_details:'评审详情',
  intelligentOfficialDoc_total_qus_comment:'整体问题批注：',
  intelligentOfficialDoc_specific_qus_comment:'具体问题批注：',
  intelligentOfficialDoc_check_require:'查看原写作素材和要求',
  intelligentOfficialDoc_practice_improve:'练习提高',
  intelligentOfficialDoc_collapse_page:'收起页面',
  intelligentOfficialDoc_to_be_reviewed:'待评审',
  intelligentOfficialDoc_expired:'已过期',
  intelligentOfficialDoc_check_results:'查看成绩',
  intelligentOfficialDoc_Status_start:'开始',
  intelligentOfficialDoc_Status_goon:'继续',
  intelligentOfficialDoc_pra_commend:'练习/自评',
  intelligentOfficialDoc_welcome_tip:'欢迎来到智能公文写作练习/自评，请完成以下练习或自评，练习/自评完成后我们会通过对您的写作内容进行智能分析来给出结果报告，并以科学的数据可视化方式来展示结果报告。',
  intelligentOfficialDoc_positive_end_time:"按截止时间倒序排列",
  intelligentOfficialDoc_reverse_end_time:"按截止时间正序排列",
  intelligentOfficialDoc_welcome_tip_txt:" 欢迎来到智能公文写作测试，请完成以下测评，测评完成后我们会通过对您的考试内容进行智能分析来给出结果报告，并以科学的数据可视化方式来展示结果报告。",
  intelligentOfficialDoc_get_time:'{hours}小时{minutes}分钟{seconds}秒',
  intelligentOfficialDoc_should_know:'{typeText}须知',
  intelligentOfficialDoc_title_label:'名称：',
  intelligentOfficialDoc_duration:'时长：',
  intelligentOfficialDoc_points_attention:'注意事项：',
  intelligentOfficialDoc_answer_rules01:'1.	开始答题后，请认真阅读答题说明，按要求答题；',
  intelligentOfficialDoc_answer_rules02:'2.	如遇网速较慢，文字、图片不能显示或系统出现意外（网络连接中断、机器故障），请退出答题，稍后或更换网络环境后重新登录，继续作答；最多只可退出10次；',
  intelligentOfficialDoc_answer_rules03:'3.	考试倒计时结束后，系统将自动交卷；',
  intelligentOfficialDoc_answer_rules04:'4.	不得以任何形式传播试题内容；系统将全程监控答题过程中截屏、抄录、复制等行为；',
  intelligentOfficialDoc_answer_rules05:'5.	系统对作弊行为自动识别，如被认定为作弊，考试成绩失效。',
  intelligentOfficialDoc_answer_rules1:'1.	自评模式下，无给定材料和时间限制。开始答题后，请根据作答要求答题。',
  intelligentOfficialDoc_answer_rules2:'2.	如遇网速较慢，文字、图片不能显示或系统出现意外（网络连接中断、机器故障），请关闭作答窗口，稍后或更换网络环境后重新登录，继续作答。',
  intelligentOfficialDoc_enter_in:'进入',
  intelligentOfficialDoc_request_timeout:'请求超时',
  intelligentOfficialDoc_full_screen_tip:'请确认开启全屏写作？',
  intelligentOfficialDoc_exit_dialog:'你已退出10次，5秒后将自动提交',
  intelligentOfficialDoc_end_dialog:'测试时间结束，5秒后将自动提交',
  intelligentOfficialDoc_submit_time:'提交（{autoSubmitTime}）',
  intelligentOfficialDoc_exit_one_time:'你刚刚退出了1次',
  intelligentOfficialDoc_exit_num01:'退出全屏计为退出1次，{warningTxt}',
  intelligentOfficialDoc_exit_num02:'你已第{opportunity}次退出，退出{OPPORTUNITY}次将自动提交。',
  intelligentOfficialDoc_keep_writing:'继续写作',
  intelligentOfficialDoc_confirm_exit:'是否确认退出',
  intelligentOfficialDoc_exit_screen01:'退出后将暂停计时、自动保存已作答内容，{warningTxt}',
  intelligentOfficialDoc_exit_screen02:"你已退出{opportunity}次，最多只可退出{OPPORTUNITY}次",
  intelligentOfficialDoc_temporary_exit:'暂时退出',
  intelligentOfficialDoc_confirm_submit:'是否提交内容',
  intelligentOfficialDoc_exit_ten_time:'最多只可退出10次，你已退出了10次，继续退出将提交内容',
  intelligentOfficialDoc_submit_content:"提交内容",
  intelligentOfficialDoc_give_material:"给定材料：",
  intelligentOfficialDoc_answer_rules:'作答要求：',
  intelligentOfficialDoc_nothing:'无',
  intelligentOfficialDoc_Entered:"已输入{richTextNum}字",
  intelligentOfficialDoc_submit:'提交',
  intelligentOfficialDoc_check_content:'提交前记得认真检查内容',
  intelligentOfficialDoc_confirm_submission:'确认提交',
  intelligentOfficialDoc_writing_exercise:'通知书写练习',
  intelligentOfficialDoc_no_discover_ques:'未出现问题',
  intelligentOfficialDoc_countdown:"倒计时：",
  intelligentOfficialDoc_scoreList:'{scoreList}分',
  intelligentOfficialDoc_get_timeNew:'{hours}时{minutes}分{seconds}秒',
  intelligentOfficialDoc_get_noHoursTime: '{minutes}分{seconds}秒',
  finshed_time: '已获学时：'
}
